import { useMutation, useQueryClient } from "@tanstack/react-query";
import { projectDetailsApi } from "./index";

export const useProjects = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (projectId?: string) => {
            return await projectDetailsApi.fetchProjectDetails(projectId);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};